<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 col-lg-3">
                <div class="card">
                    <div class="card-body">
                        <div class="w-75 m-auto">
                            <img class="img-fluid rounded-circle" src="../../../../../../assets/images/warehouse.png">
                        </div>
                    </div>
                    <div class="card-body mt-0 p-t-0 p-b-0">
                        <hr class="m-t-0">
                        <h5 class="mb-0">{{warehouse.name}}</h5>
                        <span class="" v-html="warehouse.description"/>
                        <hr>
                        <address class="mt-2">
                            <strong><i class="fas fa-map-marked-alt"/></strong><br>
                            {{warehouse.address.line1}}<br>
                            <span v-if="warehouse.address.line2">{{warehouse.address.line2}}<br></span>
                            {{warehouse.address.city}}, {{warehouse.address.state}}<br>
                            {{warehouse.address.postal_code}}, {{warehouse.address.country}}<br>
                        </address>
                    </div>
                    <div class="card-footer p-t-0 p-b-0 mb-3">
                        <hr class="m-t-0">
                        <div v-if="currentOrg.role === 'ORG_ADMIN'">
                            <router-link :to="{ name: 'editmarketplacewarehouse', params: {warehouseid: warehouseid}}"
                                         class="btn btn-info ml-auto">Edit
                            </router-link>

                            <button class="btn btn-secondary float-right">Delete</button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
            <div class="col-sm-12 col-lg-9">
                <div class="row">
                    <div class="col-12">
                        <div class="card card-blue">
                            <div class="card-header">
                                <h4 class="card-title">Create Challan</h4>
                            </div>
                            <form @submit.prevent="handleSubmitChn">
                                <div class="card-body">
                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Buyer:</label>
                                        <div class="col-sm-8">
                                            <multiselect
                                                    :class="{'is-invalid': submitted && errors.has('buyer')}"
                                                    :clear-on-select="false"
                                                    :close-on-select="true"
                                                    :hide-selected="true"
                                                    :internal-search="false"
                                                    :loading="isLoading"
                                                    :options="partners"
                                                    :searchable="true"
                                                    :show-no-results="false"
                                                    @search-change="searchPartners"
                                                    class="form-control multiselect-sm"
                                                    data-vv-as="Buyer"
                                                    label="buyer"
                                                    name="buyer"
                                                    open-direction="bottom"
                                                    placeholder="Search Buyer"
                                                    track-by="id"
                                                    v-model="challan.buyer"
                                                    v-validate="'required'">
                                                <template slot="singleLabel" slot-scope="props">
                                                    <div class="option__desc">
                                                        <div class="option__desc">
                                                            {{ props.option.org_name }}
                                                        </div>
                                                    </div>
                                                </template>
                                                <template slot="option" slot-scope="props">
                                                    <div class="option__desc">
                                                        <div class="option__desc" v-if="props.option">
                                                            <h5>{{ props.option.org_name }}</h5>
                                                        </div>
                                                        <div class="option__desc" v-else>
                                                            <h5>Add New</h5>
                                                        </div>
                                                    </div>
                                                </template>
                                            </multiselect>
                                            <div class="invalid-feedback" style="display: block"
                                                 v-if="submitted && errors.has('buyer')">{{ errors.first('buyer') }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row">
                                        <label class="col-sm-2 text-right control-label col-form-label">Reference:</label>
                                        <div class="col-sm-8">
                                            <div class="input-group">
                                                <input :class="{'is-invalid': submitted && errors.has('ref')}"
                                                       class="form-control"
                                                       data-vv-as="Challan Reference"
                                                       id="ref2"
                                                       name="ref"
                                                       placeholder="Reference"
                                                       type="text"
                                                       v-model="challan.ref"
                                                       v-validate="'required'">
                                            </div>
                                            <div class="invalid-feedback" style="display: block"
                                                 v-if="submitted && errors.has('ref')">{{ errors.first('ref') }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row" v-if="challan.items.length === 0">
                                        <label class="col-md-2 text-right control-label col-form-label">Commodity</label>
                                        <div class="col-md-4 mt-2">
                                            <a class="" data-target="#searchAndSelectCommodityModal" data-toggle="modal"
                                               href="javascript:void(0)"><b>Click here to
                                                add commodity</b></a>
                                        </div>
                                    </div>
                                    <div class="form-group row" v-for="(item,i) in challan.items">
                                        <label class="col-sm-2 text-right control-label col-form-label">Item {{i+1}}:</label>
                                        <div class="col-sm-4">
                                            <p v-if="item.good" class="form-control" style="height: 42px;">{{item.good.name}} <span
                                                    v-if="item.good.code">({{item.good.code}})</span> -
                                                {{item.good.variety}}</p>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="input-group">
                                                <input :class="{'is-invalid': submitted && errors.has('quantity'+i)}"
                                                       :id="'quantity3'+i"
                                                       :name="'quantity'+i"
                                                       class="form-control"
                                                       data-vv-as="Quantity"
                                                       placeholder="Quantity"
                                                       step="any"
                                                       type="number"
                                                       v-model="item.quantity"
                                                       v-validate="'required',`between:1,${item.limit}`">
                                                <input :class="{'is-invalid': submitted && errors.has('quantity'+i)}"
                                                       :value="item.unit" class="form-control" disabled
                                                       style="max-width: 40px">
                                            </div>
                                            <div class="invalid-feedback" style="display: block"
                                                 v-if="submitted && errors.has('quantity'+i)">{{
                                                errors.first('quantity'+i) }}
                                            </div>
                                        </div>
                                        <div class="col-sm-2">
                                            <button data-target="#searchAndSelectCommodityModal"
                                                    data-toggle="modal" class="btn btn-success mr-2" title="Add More Item"
                                                    type="button" v-if="challan.items.length === 1 || i === challan.items.length-1">
                                                <i class="fa fa-plus"/>
                                            </button>
                                            <button @click="removeItem(i)" class="btn btn-danger" title="Remove This Item"
                                                    type="button">
                                                <i class="fa fa-minus"/>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="form-group m-b-0 text-right">
                                        <div class="button-group">
                                            <button class="btn waves-effect waves-light btn-success" type="submit">
                                                Save
                                            </button>
                                            <button class="btn waves-effect waves-light btn-secondary" type="reset">
                                                Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <search-select-commodity v-if="coommoditiesForChallan.length > 0" :checked-commodity-ids="commodityIds" :pre-commodities="coommoditiesForChallan"
                                 @commodity-select="setCommodity"></search-select-commodity>
    </div>
</template>

<script>
    import Multiselect from "vue-multiselect";
    import SearchSelectCommodity from "../../../../common/SearchSelectCommodity";
    import {mapGetters} from "vuex";

    export default {
        name: "ChallanFromWarehouse",
        components: {SearchSelectCommodity, Multiselect},
        props: ["marketplaceid", "warehouseid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                submitted: false,
                warehouses: [],
                warehouse: {
                    name: null,
                    description: null,
                    address: {
                        line1: null,
                        line2: null,
                        city: null,
                        state: null,
                        postal_code: null,
                        country: null
                    },
                    inventory: [],
                },
                isLoading: false,
                partners: [],
                challan: {
                    buyer: null,
                    items: [
                    //     {
                        //     good: null,
                        //     quantity: null,
                        //     unit: null,
                        //     limit: 0
                        // }
                    ],
                    ref: null
                },
                commodityIds: [],
                coommoditiesForChallan: []
            }
        },
        mounted() {
            this.getWareHouse();
        },
        methods: {
            async searchPartners(searchText) {
                try {
                    this.isLoading = true;
                    let reply = await this.$http.get("/marketplaces/" + this.currentOrg.marketplace_id + "/members/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.partners = reply.data;
                    this.isLoading = false;
                } catch (e) {
                    console.log(e);
                }
            },
            async getWareHouse() {
                let reply = await this.$http.get(`/marketplaces/${this.marketplaceid}/warehouses/${this.warehouseid}`);
                this.warehouse = reply.data;
                this.coommoditiesForChallan = this.warehouse.inventory.filter(comm=> Number(comm.stock) !== 0)
            },
            async searchWareHouses(search) {
                let reply = await this.$http
                    .get(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses`, {
                        params: {
                            search
                        }
                    });
                this.warehouses = _.filter(reply.data.warehouses, (w) => {
                    return w.id !== Number(this.warehouseid)
                });
            },
            removeItem(i) {
                this.challan.items.splice(i, 1);
                this.commodityIds = this.challan.items.map(row => row.good.id);
            },
            handleSubmitChn() {
                this.submitted = true;
                this.$validator.validate()
                    .then(valid => {
                        console.log(valid)
                        if (valid) {
                            this.createChallan();
                        }
                    });
            },
            async createChallan() {
                console.log("reqbody", this.challan);
                try {
                    let payload = {
                        buyer_id: this.challan.buyer.org_id,
                        ref: this.challan.ref,
                        items: this.challan.items.map(ci => ({
                            commodity_id: ci.good.id,
                            quantity: ci.quantity,
                            unit_id: ci.good.unit.id
                        }))
                    };

                    let {data} = await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/warehouses/${this.warehouseid}/challan`, payload)
                    this.$toastr('success', 'Challan created', 'Success');
                    this.challan.items = [{
                        good: null,
                        quantity: null,
                        unit: null,
                        limit: 0
                    }];
                    this.challan.buyer = null;
                    this.challan.ref = null;
                    this.submitted = false;
                    await this.$router.push({name: 'marketplaceviewchallan', params: {challanid: data.challanid}})
                } catch (e) {
                    this.$toastr('error', 'Could not create challan', 'Failed');
                }
            },
            setCommodity(e) {
              console.log('challan commodities', e);
                let commodities = e;
                commodities.forEach(c=> {
                    let found = this.challan.items.find(row=> row.good.commodity_id === c.id);
                    if(!found){
                        this.challan.items.push({
                            good: {
                                commodity_id: c.id,
                                commodity_name: c.name,
                                unit_id: c.unit ? c.unit.id : null,
                                unit_name: c.unit ? c.unit.name : null,
                                unit_symbol: c.unit ? c.unit.symbol : null,
                                ...c
                            },
                            quantity: null,
                            unit: c.unit,
                            limit: Number(c.stock)

                        })
                    }
                })
                this.commodityIds = commodities.map(c=> c.id);
            }
        }
    }
</script>

<style scoped>

</style>
